import { Text, View } from 'react-native'
import { useRouter } from 'expo-router'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/base'
import { Description } from '@/components/icon'
import { Stack } from '@/components/layout'
import NavigationBar from '@/components/NavigationBar'

function NotFoundScreen() {
  const { t } = useTranslation()
  const router = useRouter()

  const handlePress = () => {
    router.dismissAll()
    router.replace('/home')
  }

  return (
    <>
      <Stack.Screen options={{ header: () => <NavigationBar /> }} />
      <View className={'flex-1 items-center justify-center'}>
        <View className={'items-center gap-4'}>
          <Description className={'size-20 text-text-quaternary'} />
          <Text className={'text-sm text-text-secondary'}>{t('ui:noContent')}</Text>
          <Button size={'md'} intent={'primary'} variant={'solid'} onPress={handlePress}>
            {t('ui:returnHome')}
          </Button>
        </View>
      </View>
    </>
  )
}

export default NotFoundScreen
